import * as actions from './actions'
import { arrayToObject, addUpdateItem, removeItem } from '../../../functions'
import { createActionTypeReducer} from '../../../middleware'

const initialState = {
    items: {}
}

export const groupReducer = createActionTypeReducer({}, {
    [actions.CREATE_GROUP_SUCCESS]: (state, action) => ({ ...state, ...addUpdateItem(state, action) }),
    [actions.UPDATE_GROUP_SUCCESS]: (state, action) => ({ ...state, ...addUpdateItem( state, action) }),
    [actions.DELETE_GROUP_SUCCESS]: (state, action) => ({ ...removeItem( state, action ) }),
})

export const groupsReducer = createActionTypeReducer(initialState, {
    [actions.GET_GROUPS_SUCCESS]: (state, action) => ({ ...state, items: arrayToObject(action.payload.items) }),
},
    (state, action) => {
        return {
            ...state,
            items: groupReducer(state.items, action)
        }
    }
)




// WEBPACK FOOTER //
// ./src/App/Admin/Groups/reducers.js